var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65518 2C9.65518 0.89543 8.79062 1.66491e-09 7.72414 0C6.65766 -1.66491e-09 5.79311 0.895429 5.79311 2L5.7931 13.1716L3.29648 10.5858C2.54237 9.80474 1.3197 9.80474 0.565586 10.5858C-0.188529 11.3668 -0.188528 12.6332 0.565587 13.4142L6.35869 19.4142C6.72083 19.7893 7.21199 20 7.72414 20C8.23628 20 8.72745 19.7893 9.08959 19.4142L14.8827 13.4142C15.6368 12.6332 15.6368 11.3668 14.8827 10.5858C14.1286 9.80474 12.9059 9.80474 12.1518 10.5858L9.65517 13.1716L9.65518 2Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.72414,
    y1: 0,
    x2: 7.72414,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59B9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D92A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.73f3b6c3.svg";
export { ForwardRef as ReactComponent };